<template>
    <div class="fast_preview_files shadow" >
        <b-table class="table-responsive-lg"  thead-class="bg-primary text-white striped "   :items="files" :fields="fields">
            <template  v-slot:head(link)="data">
                <span class="fs-xl text-center" v-html="data.label"></span>
            </template>

            <template v-slot:head(remove)="data">
                <span class="fs-xl text-center" v-html="data.label"></span>
            </template>

            <template  v-slot:cell(link)="data" >
                <span class="get_file cursor-pointer" @click="get_file(data.item)">
                     <i class="fal  fa-save save_me"></i>
                </span>
            </template>

            <template  v-slot:cell(remove)="data" >
                <i class="fas fa-trash fs-xl" @click="remove_item(data.item)" ></i>
            </template>

        </b-table>
    </div>

</template>

<script>
    export default {
        name: "fast_files",

        props: {
            files: {
                type: Array,
                required :true
            },
        },
        data() {
            return {

                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: 'Назва',
                        sortable: true
                    },
                    {
                        key: 'user_small',
                        label: 'ПIБ',
                        sortable: true
                    },
                    {
                        key: 'added',
                        label: 'Дата',
                        sortable: true
                    },
                    {
                        key : 'link',
                        label: '<i class="fal fa-save"></i>',
                        sortable: false
                    },
                ],
            }
        },
        
        methods : {
            
            get_file(item) {
                
                api.get('/files/' + item.id, { responseType: 'blob' }) // responseType важен!
                    .then(response => {
                        if (response.status === 200) {
                            const fileType = response.headers['content-type'] || '';
                            const fileBlob = new Blob([response.data], { type: fileType });
                            const fileURL = window.URL.createObjectURL(fileBlob);
                            
                            if (fileType.includes('pdf') || item.name.toLowerCase().endsWith('.pdf')) {
                                window.open(fileURL, '_blank');
                            } else {
                                const fileLink = document.createElement('a');
                                fileLink.href = fileURL;
                                fileLink.setAttribute('download', item.name);
                                document.body.appendChild(fileLink);
                                fileLink.click();
                                document.body.removeChild(fileLink);
                            }
                        } else {
                            EventBus.$emit('show_toast', { err: 'File not found', type: "danger", title: 'Error' });
                        }
                    })
                    .catch(err => {
                        EventBus.$emit('show_toast', { err: err.message, type: "danger", title: err.name });
                    })
                    .finally(() => {
                    });
            },
        }


    }
</script>

<style scoped>

</style>
